module.exports = __webpack_public_path__ + "img/robson-hatsukami-morgan-RTKaEcGKarQ-unsplash.cc7e7e5d.jpg";